(function () {
  'use strict';

    angular.module('eclipseApp.myAccount').filter('nameFormatter', ['$filter', function nameFormatter($filter){
          return function(text){
            var length = text.length ;
            if(length > 14){
              var name = text.substring(0,14) + '...' ;
            }else{
              var name = text;
            }
            return name;
          }
        }]);

})();

